export default __webpack_public_path__ + "static/media/Step3-AI.5641c5fe.svg";